import { typedQueryClient, useTypedQuery } from "hooks";
import { LEAD_TYPES } from "modules/LeadsDashboard";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";

export const useSelectedLeadType = () => useTypedQuery({ queryKey: LeadsQueryKeys.selectedLeadType, initialData: LEAD_TYPES.Snoozed }).data;
export const setSelectedLeadType = (selectedLeadType: LEAD_TYPES) => typedQueryClient.setQueryData(LeadsQueryKeys.selectedLeadType, selectedLeadType);
